import React, { useEffect } from 'react'
import { LeverageInstrumentDto } from 'api/Trading-Accounts/Types/InstrumentDto'
import { UpdateLeverageInstrument } from 'api/Trading-Accounts/Types/UpdateLeverageInstrument'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchTradingAccountsLeverageTypesAction } from 'store/trading-accounts/trading-accounts.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { isEmpty } from 'utils/is-empty'

import { LeverageEditForm } from './forms/LeverageEditForm'

interface Props {
  isOpen?: boolean
  onClose(): void
  leverage?: LeverageInstrumentDto
  onUpdateLeverageInstrument(values: UpdateLeverageInstrument): Promise<void>
}

export const LeverageEditPage: React.FC<Props> = ({
  isOpen,
  onClose,
  leverage,
  onUpdateLeverageInstrument,
}) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const dispatch = useAppDispatch()

  const leverages = useAppSelector((state) => state.tradingAccounts.leverages)

  useEffect(() => {
    if (isEmpty(leverages))
      dispatch(fetchTradingAccountsLeverageTypesAction(tradingAccountsApiClient))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LeverageEditForm
      isOpen={isOpen}
      onClose={onClose}
      leverage={leverage}
      leverages={leverages}
      onSubmit={onUpdateLeverageInstrument}
    />
  )
}
